import { parrotApi } from '@libs/openapi';
import { useEffect, useState } from 'react';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';
import { useAddress } from './use-address';
import { useRefreshTime } from './use-refresh';

export const useVaultPortfolio = () => {
  const address = useAddress();
  const [portfolio, setPortfolio] =
    useState<OpenapiClientParrotVault.GetVaultStatsPortfolioResponse>();
  const [_, setPreTime] = useState(0);
  const { updateRefresh } = useRefreshTime();

  const getVaultPortfolio = async () => {
    if (!address) {
      setPortfolio(undefined);
      return;
    }
    const result = await parrotApi.get('/vault/stats/portfolio', {
      query: {
        owner: address,
      },
    });
    setPortfolio(result);

    setPreTime((pre) => {
      if (pre === result.timestamp) {
        return pre;
      }
      if (pre !== 0) {
        updateRefresh(60);
      }
      return result.timestamp;
    });
  };

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    const loop = () => {
      getVaultPortfolio();
      timer = setTimeout(() => {
        loop();
      }, 3000);
    };
    loop();
    return () => {
      clearTimeout(timer);
    };
  }, [address]);

  return {
    portfolio,
  };
};
